document.addEventListener('DOMContentLoaded', () => {
    let selector = 'input[name="cms_third_party_claim_intimation[beneficiary_bank_nationality]"]';
    let tp_claim_intimation_bank_nationalities = document.querySelectorAll(selector);

    if (tp_claim_intimation_bank_nationalities.length === 0) {
        selector = 'input[name="cms_third_party_beneficiary[bank_nationality]"]';
        tp_claim_intimation_bank_nationalities = document.querySelectorAll(selector);
    }

    if (tp_claim_intimation_bank_nationalities.length !== 0) {
        let tp_claim_intimation_bank_nationality_selected = null;

        for (var i = 0, len = tp_claim_intimation_bank_nationalities.length; i < len; ++i) {
            if (tp_claim_intimation_bank_nationalities[i].checked) {
                tp_claim_intimation_bank_nationality_selected = tp_claim_intimation_bank_nationalities[i];
                break;
            }
        }

        if (tp_claim_intimation_bank_nationality_selected !== null) {
            let to_be_displayed;
            let to_be_hidden;

            let saudi_group_form = document.querySelectorAll('.saudi_bank_attributes_container');
            let non_saudi_group_form = document.querySelectorAll('.non_saudi_bank_attributes_container');

            switch (tp_claim_intimation_bank_nationality_selected.value) {
                case 'saudi':
                    saudi_group_form.forEach(function (e) {
                        e.classList.remove('hidden');
                    });

                    break;

                case 'non-saudi':
                    non_saudi_group_form.forEach(function (e) {
                        e.classList.remove('hidden');
                    });

                    break;

                default:
                    break;
            }

            $(selector).click(function () {
                switch (this.value) {
                    case 'saudi':
                        to_be_displayed = saudi_group_form;
                        to_be_hidden = non_saudi_group_form;
                        break;

                    case 'non-saudi':
                        to_be_displayed = non_saudi_group_form;
                        to_be_hidden = saudi_group_form;
                        break;

                    default:
                        break;
                }

                to_be_displayed.forEach(function (e) {
                    e.classList.remove('hidden');
                });

                to_be_hidden.forEach(function (e) {
                    e.classList.add('hidden');
                });
            });
        }
    }
});
